export default __webpack_public_path__ + "static/media/landstar.e7c5feb7.png";